import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5230ca0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-instructions-StepFour-component" }
const _hoisted_2 = { class: "step-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-subtitle" }, " Preencha as informações abaixo para contribuir com pesquisas que ajudam no enfrentamento do HIV. As respostas são voluntárias, você deve respondê-las completamente ou seguir sem informar. ", -1))
const _hoisted_4 = { class: "col-12 toggle-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "switch" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-text" }, " Preencher usando minha localização ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkboxTerm" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terms-and-law" }, [
  /*#__PURE__*/_createTextVNode(" Declaro que li e aceito os "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://clinicarx.com.br/termos-de-uso-pacientes",
    target: "_blank"
  }, " Termos de Uso para Pacientes "),
  /*#__PURE__*/_createTextVNode(" e "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://clinicarx.com.br/politica-de-privacidade/",
    target: "_blank"
  }, " Política de Privacidade "),
  /*#__PURE__*/_createTextVNode(" e que informei corretamente os dados solicitados para uso de serviços de saúde com a Clinicarx. ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terms-and-law" }, " Seguimos a Lei nº 14.289/2022 e a Lei 13.709/2018 quanto ao sigilo e segurança das informações que você está disponibilizando nesta jornada. ", -1))
const _hoisted_11 = {
  key: 0,
  class: "terms-and-law minorAge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_floating_card = _resolveComponent("floating-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "4",
      stepTitle: this.StepContent.title,
      nextButtonActive: "",
      onNextStep: _cache[8] || (_cache[8] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[9] || (_cache[9] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_alert_box, {
            class: "mb-10 mt-8",
            info: "",
            stepContent: _ctx.StepContent
          }, null, 8, ["stepContent"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.toggleActive ? 'toggle-active' : 'toggle'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlerToggleLocation && _ctx.handlerToggleLocation(...args)))
            }, _hoisted_6, 2),
            _hoisted_7
          ]),
          _createVNode(_component_base_select, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-state",
            label: "1. Qual seu Estado?",
            placeholder: "Pesquise Estado",
            keyLabel: "nome",
            keyValue: "sigla",
            searchable: "",
            validatorType: _ctx.requiredField,
            availableOptions: _ctx.states,
            required: _ctx.validRequiredFields,
            onChange: _ctx.handlerStateChange,
            modelValue: _ctx.patient.state,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patient.state) = $event)),
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "availableOptions", "required", "onChange", "modelValue", "removeMessages"]),
          _createVNode(_component_base_select, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-city",
            label: "2. Qual sua Cidade?",
            placeholder: "Pesquise Cidade",
            keyLabel: "nome",
            keyValue: "nome",
            searchable: "",
            validatorType: _ctx.requiredField,
            availableOptions: _ctx.cities,
            required: _ctx.validRequiredFields,
            modelValue: _ctx.patient.city,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patient.city) = $event)),
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "availableOptions", "required", "modelValue", "removeMessages"]),
          _createVNode(_component_base_input, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-age",
            id: "form-age",
            inputmode: "numeric",
            label: "3. Qual sua idade?",
            placeholder: "Insira a idade em anos",
            mask: "###",
            validatorType: _ctx.requiredAge,
            required: _ctx.validRequiredFields,
            removeMessages: _ctx.removeMessages,
            modelValue: _ctx.patient.age,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patient.age) = $event))
          }, null, 8, ["validatorType", "required", "removeMessages", "modelValue"]),
          _createVNode(_component_base_select, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-gender",
            label: "4. Qual seu gênero?",
            placeholder: "Selecione o gênero",
            validatorType: _ctx.requiredField,
            orderItems: false,
            availableOptions: _ctx.genderOptions,
            required: _ctx.validRequiredFields,
            modelValue: _ctx.patient.gender,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patient.gender) = $event)),
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "availableOptions", "required", "modelValue", "removeMessages"]),
          _createVNode(_component_base_select, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-sexual-orientation",
            label: "5. Qual sua orientação sexual?",
            placeholder: "Selecione a orientação sexual",
            validatorType: _ctx.requiredField,
            orderItems: false,
            availableOptions: _ctx.orientationOptions,
            modelValue: _ctx.patient.sexual_orientation,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patient.sexual_orientation) = $event)),
            removeMessages: _ctx.removeMessages,
            required: _ctx.validRequiredFields
          }, null, 8, ["validatorType", "availableOptions", "modelValue", "removeMessages", "required"]),
          _createVNode(_component_base_select, {
            class: "mb-2 hiv-field",
            type: "text",
            ref: "form-education-level",
            label: "6. Qual sua escolaridade?",
            placeholder: "Selecione a escolaridade",
            validatorType: _ctx.requiredField,
            orderItems: false,
            availableOptions: _ctx.scholarityOptions,
            required: _ctx.validRequiredFields,
            modelValue: _ctx.patient.education_level,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patient.education_level) = $event)),
            removeMessages: _ctx.removeMessages
          }, null, 8, ["validatorType", "availableOptions", "required", "modelValue", "removeMessages"]),
          _createElementVNode("div", {
            class: _normalizeClass(["custom-checkbox mb-2", { 'checkbox-error': _ctx.mustAccept && !_ctx.patient.accept_terms }])
          }, [
            _withDirectives(_createElementVNode("input", {
              id: "checkboxTerm",
              name: "terms",
              type: "checkbox",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patient.accept_terms) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.patient.accept_terms]
            ]),
            _hoisted_8,
            _hoisted_9
          ], 2),
          _hoisted_10,
          (_ctx.minorAge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Você possui menos de 12 anos. Ao prosseguir, você confirma que realizou o teste sob a supervisão de adulto responsável. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["stepTitle"])
  ]))
}